import github from "./github";
import heart from "./heart";
import notFound from "./notFound";

const icon = {
    github,
    heart,
    notFound,
};

export default icon;
